<template>
  <div class="znzz">
    <div class="header">
      <div class="zhuti">
        <div class="h1">实体产能共享</div>
        <div class="h2">
          <p>盘活存量资产，激活闲置产能</p>
            <p> 一站式解决产品与品牌视觉需求</p>
        </div>
      </div>
    </div>
    <div class="title">
      服务流程
    </div>
    <div class="content">
      <div class="right">
        <div class="right1"></div>
        <div class="right2"></div>
      </div>
      <div class="line"></div>
      <div class="lists">
        <div v-for="(item,index) in arr " :key="index" class="list">
          <div class="yuan">{{index+1}}</div>
          <div class="name">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="zhuti">
        <div class="wrapper">
          <div v-for="(it,index) in arr1" :key="index" class="item">
            <div class="image">
              <el-image :src="it.src"></el-image>
              <div style="position: absolute;top: 0;left: 0;right: 0;bottom: 0;">
                <div class="text">{{it.name}}</div>
                <div class="neirong">
                  <p>为有临时性或季节性订单需求的企业提供灵活生产解决方案，实现资源优化配置。</p>
                  <p>闲置产能可视化、共享产能地图、灵活生产</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="bg">
      <div class="zhuti">
        <div class="wrapper1">
          <div v-for="(it,index) in arr2" :key="index" class="item">
            <div class="image">
              <el-image :src="it.src"></el-image>
            </div>
            <div class="name1">{{it.name1}}</div>
            <div class="name2">{{it.name2}}</div>
            <div class="name3">{{it.name3}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {networksecurityindex} from "../../request/moudle/shengtai";
export default {
  name: "",
  data(){
    return  {
      datas:'',
      number:0,
      arr2:[{name1:'张丽',name2:'财务总监',name3:'擅长领域：财务体系建立、税务筹划'},{name1:'张丽',name2:'财务总监',name3:'擅长领域：财务体系建立、税务筹划'},
        {name1:'张丽',name2:'财务总监',name3:'擅长领域：财务体系建立、税务筹划'},{name1:'张丽',name2:'财务总监',name3:'擅长领域：财务体系建立、税务筹划'},
        {name1:'张丽',name2:'财务总监',name3:'擅长领域：财务体系建立、税务筹划'},{name1:'张丽',name2:'财务总监',name3:'擅长领域：财务体系建立、税务筹划'},
        {name1:'张丽',name2:'财务总监',name3:'擅长领域：财务体系建立、税务筹划'},{name1:'张丽',name2:'财务总监',name3:'擅长领域：财务体系建立、税务筹划'}],
      arr1:[{name:'工厂共享',src:require('../../assets/shengtai/shi1.png')},
        {name:'仓库共享',src:require('../../assets/shengtai/shi2.png')},
        {name:'加工设备共享',src:require('../../assets/shengtai/shi3.png')}],
      arr3:[{name:'融资协议审查',src:require('../../assets/shengtai/gao5.png')},
        {name:'税务筹划',src:require('../../assets/shengtai/gao6.png')},
        {name:'重大合同起草审核',src:require('../../assets/shengtai/gao7.png')},
        {name:'资质申报指导',src:require('../../assets/shengtai/gao8.png')},
        {name:'日常法律风险防范',src:require('../../assets/shengtai/gao9.png')},
        {name:'成本管控分析',src:require('../../assets/shengtai/gao10.png')}],
      arr:[{name:'选择服务类型'},{name:'匹配/选择专家'},{name:'在线沟通确认需求'},{name:'平台签约'},{name:'服务交付'},{name:'完成评价'}],
    }
  },
  created() {
    //this.loadconfig()
  },
  methods:{
    go(index){
     if(index==1){
        thi.$router.push({
          path:'/'
        });
     }else if(index==2){

     }else if(index==3){

     }
    },
    loadconfig(){
      this.$api.znzz.networksecurityindex().then((res)=>{
        this.datas=res.data
        this.moreList=res.data.moreList
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.znzz{
  width: 100%;
  background: #fff;
}
.wrapper{
  display: grid;
  grid-template-columns: repeat(3, 390px);
  grid-gap: 15px;
  font-size: 16px;
  font-weight: bolder;
  .item{
    //box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    cursor: pointer;
  }
  .image{
    position: relative;
    text-align: center;
    .text{
      position: absolute;
      width: 100%;
      margin-left: -50%;
      top: 50%;
      left: 50%;
      color: #fff;
    }
    .neirong{
      opacity: 0; /* 初始透明度为0 */
      transition: opacity 0.5s ease; /* 添加动画效果 */
      position: absolute;
      width: 80%;
      margin-left: -40%;
      top: 160px;
      left: 50%;
      color: #fff;
      font-size: 14px;
      font-weight: normal;
    }
    img{
      width: 595px;
      height: 220px;
    }
  }
  .item:hover .neirong {
    opacity: 1; /* 鼠标悬停时变为不透明 */
    top: 160px;
  }
  .item:hover .text {
    top: 110px;
  }
  .name{
    text-align: left;
    line-height: 10px;
    padding: 20px 35px;
  }
}
.bg{
  background: #f1f6fc;
  padding: 50px 0;
  margin-top: 50px;
}
.wrapper1{
  display: grid;
  grid-template-columns: repeat(4, 280px);
  grid-gap: 20px;
  font-size: 18px;
  font-weight: bolder;
  text-align: center;
  margin-top: 35px;
  .item{
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 32px;
    background: #fff;

  }
  .image{
    position: relative;
    text-align: center;
    img{
      width: 130px;
      height: 130px;
      border-radius: 50%;
    }
  }
  .name1{
    font-size: 16px;
    font-weight: bolder;
  }
  .name2{
    font-size: 14px;
    font-weight: bolder;
    padding: 10px 0 30px 0;
  }
  .name3{
    font-size: 14px;
    color:#666666

  }
}
.header{
  width: 100%;
  height: 280px;
  background: url("../../assets/banner/gaoduan.png") no-repeat;
  background-size: 100% 100%;
  padding-top: 90px;
  z-index: 10;
  color: #1D1D1D;
  position: relative;
  ::after{
    content: "";
    top: 0;
    width: 100%;
    left: 0;
    height: 70px;
    background:rgba(0, 66, 164, 0.1);
    position: absolute;
  }
  .h1{
    font-size: 42px;
    margin-top: 55px;
  }
  .h2{
    font-size: 20px;
    line-height: 30px;
    margin-top: 15px;
  }
}

.zhuti{
  width: 1200px;
  margin: 0px auto;
}
.content{
  width: 1200px;
  margin: 0 auto;
  padding: 24px;
  height: 193px;
  position: relative;
  .right{
    position: absolute;
    right: -200px;
    top: 0px;
    .right1{
      width: 200px;
      height: 270px;
      background: url("../../assets/shengtai/gao3.png") no-repeat;
      background-size: 100% 100%;
    }
    .right2{
      width: 200px;
      height: 209px;
      background: url("../../assets/shengtai/gao4.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .line{
    position: absolute;
    width: 900px;
    margin-left: 146px;
    margin-top: 45px;
    border: 1px dashed #0079E9;
    z-index: 1;
  }
  .lists{
    width: 100%;
    position: absolute;
    z-index: 2;
  }
  .list{
    float: left;
    margin-left: 86px;
    .yuan{
      width: 90px;
      height: 90px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      background: #FFFFFF;
      line-height: 90px;
      text-align: center;
      font-size: 16px;
      font-weight: bolder;
      color: #355FA8;
      margin: 0 auto;
    }
    .name{
      margin-top: 24px;
      font-size: 16px;
      font-weight: bolder;
      text-align: center;
    }
  }
}
.title{
  font-size: 24px;
  text-align: center;
  padding: 35px 0;
}
</style>